<template>
  <button
    class="tooth-popup"
    type="button"
    v-bind:class="{ flip, selected }"
    v-on:click="toggle">
    <svg
      class="tooth-popup__parts"
      width="26"
      height="51"
      viewBox="0 0 26 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3678 24.6134C19.6314 23.6601 20.1725 17.6536 20.4102 14.7695L5.59275 14.8731C6.03215 19.4152 7.04277 29.5975 7.57004 33.991C8.22913 39.4829 11.8541 45.9073 13.4359 47.7207C15.0178 49.534 17.8519 49.7413 17.1928 46.2182C16.5337 42.6951 17.2587 35.3381 17.5223 33.4211C17.7859 31.5042 19.0382 25.8051 19.3678 24.6134Z" />
      <path d="M6.3178 4.30246C8.84871 2.23007 11.8542 1.67743 13.0405 1.66016C13.7521 1.80518 14.4371 2.0088 15.0896 2.25385C20.1468 4.15304 23.2605 10.1792 20.4102 14.7681C20.115 15.2434 19.7698 15.7123 19.3678 16.167C16.3623 19.5657 12.4034 19.1374 10.7996 18.4984C9.85492 18.0494 7.49098 16.6954 5.5928 14.8717C3.69461 13.048 3.52764 10.2779 3.68143 9.12079C3.74734 8.34364 3.78689 6.37486 6.3178 4.30246Z" />
    </svg>
    <div class="tooth-popup__number">{{number}}</div>
  </button>
</template>

<script>
import popupTeethMixin from '@/mixins/popupTeethMixin';

export default {
  mixins: [popupTeethMixin],
  name: 'ToothDown3',
};
</script>

<style>
</style>
